import React, { useEffect } from 'react';
import LandingNavbar from '../components/Landing/LandingNavbar';
import LandingFooter from '../components/Landing/LandingFooter';
import './landing.css';
import aiBrain from '../assets/ai_brain.png';

const FeaturesPage: React.FC = () => {
    useEffect(() => {
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate-in');
                }
            });
        }, observerOptions);

        document.querySelectorAll('.feature-card, .tech-item').forEach(el => {
            observer.observe(el);
        });

        return () => observer.disconnect();
    }, []);

    return (
        <div className="main-landing-admin">
            <LandingNavbar />

            <section className="hero-sub">
                <div className="container hero-sub-container">
                    <div className="hero-sub-content">
                        <h1 className="section-title gradient-text" style={{ textAlign: 'left', marginBottom: '1.5rem' }}>Advanced <span>AI Features</span></h1>
                        <p className="hero-description" style={{ color: 'rgba(255,255,255,0.85)', fontSize: '1.25rem', lineHeight: '1.6' }}>
                            Discover the powerful capabilities that make Asknow the leading AI platform for business intelligence.
                        </p>
                        <div style={{ marginTop: '2rem' }}>
                            <div className="tech-badge" style={{ display: 'inline-block', marginRight: '1rem', marginBottom: '1rem' }}>99.9% Accuracy</div>
                            <div className="tech-badge" style={{ display: 'inline-block', marginRight: '1rem', marginBottom: '1rem' }}>Real-time Insights</div>
                        </div>
                    </div>

                    <div className="featured-image-container">
                        <img src={aiBrain} alt="AI Intelligence" className="featured-image" />
                    </div>
                </div>
            </section>

            <section style={{ padding: '6rem 0' }}>
                <div className="container">
                    <h2 className="section-title">Core <span>Capabilites</span></h2>
                    <div className="features-grid">
                        <div className="feature-card">
                            <div className="feature-icon">
                                <i className="fas fa-robot"></i>
                            </div>
                            <h3>Machine Learning</h3>
                            <p>Our neural networks adapt in real-time to your unique business data, providing insights that go beyond standard analytics.</p>
                        </div>
                        <div className="feature-card">
                            <div className="feature-icon">
                                <i className="fas fa-chart-line"></i>
                            </div>
                            <h3>Predictive Analytics</h3>
                            <p>Forecast market trends and customer behavior with up to 98% accuracy using our proprietary prediction models.</p>
                        </div>
                        <div className="feature-card">
                            <div className="feature-icon">
                                <i className="fas fa-shield-alt"></i>
                            </div>
                            <h3>Enterprise Security</h3>
                            <p>Your data is encrypted with AES-256 at rest and in transit. We follow strict compliance standards for your peace of mind.</p>
                        </div>
                        <div className="feature-card">
                            <div className="feature-icon">
                                <i className="fas fa-bolt"></i>
                            </div>
                            <h3>Real-time Processing</h3>
                            <p>Experience zero-latency data processing. Get answers to complex questions in milliseconds, not minutes.</p>
                        </div>
                        <div className="feature-card">
                            <div className="feature-icon">
                                <i className="fas fa-brain"></i>
                            </div>
                            <h3>NLP Understanding</h3>
                            <p>Our Natural Language Processing engine understands context, tone, and intent, making interactions feel truly human.</p>
                        </div>
                        <div className="feature-card">
                            <div className="feature-icon">
                                <i className="fas fa-network-wired"></i>
                            </div>
                            <h3>Seamless Integration</h3>
                            <p>Connect Asknow to your existing stack with our robust API and one-click integrations for major platforms.</p>
                        </div>
                    </div>
                </div>
            </section>

            <LandingFooter />
        </div>
    );
};

export default FeaturesPage;
